import { RECIPE_NAME_CALENDULA, RECIPE_NAME_DAHLIA } from 'constants/recipes';

/* Rules */
export const BASE_SINGLE_IMAGE_GATSBY_CSS_RULES = ['objectFit'];
export const BASE_SINGLE_IMAGE_BACKGROUND_CSS_RULES = ['backgroundSize'];

export const BASE_SINGLE_IMAGE_CSS_RULES = [
  'minHeight',
  'maxHeight',
  'clipPath',
  'border',
  'boxShadow',
];

export const BASE_SINGLE_IMAGE_CONTENT_CSS_RULES = [
  'padding',
  'background',
  'color',
  'justifyContent',
  'alignItems',
];

export const SINGLE_IMAGE_CONTENT_CSS_RULES = {
  [RECIPE_NAME_CALENDULA]: [],
  [RECIPE_NAME_DAHLIA]: [],
};

export const MAIN_SINGLE_IMAGE_CSS_RULES = [];

export const SINGLE_IMAGE_CSS_RULES_BY_RECIPE = {
  [RECIPE_NAME_CALENDULA]: ['borderRadius'],
  [RECIPE_NAME_DAHLIA]: ['borderRadius'],
};

export const STYLE_LABEL_MAP = {
  justifyContent: 'Vertical Alignment',
  alignItems: 'Horizontal Alignment',
  background: 'Background Overlay',
  color: 'Text Overlay Color',
};

/* Defaults */
export const BASE_SINGLE_IMAGE_FIXED_STYLES = {};

export const BASE_SINGLE_IMAGE_DEFAULT_STYLES = {
  minHeight: '240px',
  backgroundSize: 'cover',
};

export const BASE_SINGLE_IMAGE_CONTENT_FIXED_STYLES = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'scroll',
};

export const BASE_SINGLE_IMAGE_CONTENT_DEFAULT_STYLES = {
  padding: '16px',
  color: '#FFFFFF',
  background: 'rgba(0,0,0,0.62)',
  alignItems: 'center',
  justifyContent: 'center',
};
